import { useSearchParams, useWindowSize } from "helpers/hooks"
import { useParams, useLocation } from "react-router-dom"
import PageLayout from "pages/layout/PageLayout"
import TabItem from "pages/projects/molecules/TabItem"
import { useEffect, useState } from "react"
import { includes } from "lodash"
import { GroupTab } from "./organisms/GroupTab"
import { ProjectTab } from "./organisms/ProjectTab"
import { ReactComponent as UserIcon } from "assets/images/user.svg"
import { pushTo } from "helpers/history"
import { PATH } from "constants/path"
import Button from "components/Button/Button"
import { hasPermission } from "helpers/permissions"
import { PERMISSIONS } from "constants/permissions"
import { useAppSelector } from "hooks/useApp"
import { BreadcrumbsDetail } from "components/Breadcrumbs/types"
import Breadcrumbs from "components/Breadcrumbs"

export const AssignmentPage = () => {
  const { isMobile } = useWindowSize()
  const userInfo = useAppSelector((state) => state.userInfo)
  const { userId } = useParams<{ userId: string }>()
  const location = useLocation() as any
  const [tab, setTab] = useState<string>("group")
  const { searchParams, setSearchParams } = useSearchParams()
  const roleName = location.state?.roleName
  const [tabs] = useState<{ name: string; path: string }[]>([
    { name: "Assigned Groups", path: "group" },
    { name: "Assigned Projects", path: "project" },
  ])

  useEffect(() => {
    const tabFromUrl = searchParams?.tab || "group"
    if (includes(["group", "project"], tabFromUrl)) {
      setTab(tabFromUrl)
    } else {
      setTab("group")
      setSearchParams({ tab: "group" })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams?.tab])

  const listBreadcrumbs: BreadcrumbsDetail[] = [
    {
      name: "Users & Groups",
      path: PATH.userGroups,
    },
    {
      name: "",
    },
  ]
  const renderHeader = () => {
    return (
      <div className="flex items-center  h-full px-[24px]">
        {roleName ? (
          <Breadcrumbs
            listBreadcrumbs={listBreadcrumbs}
            className="flex w-[133px]"
            overflow
          />
        ) : null}

        <div
          className="flex items-center h-full"
          style={{
            gap: isMobile && tabs.length > 2 ? 0 : 24,
            justifyContent:
              isMobile && tabs.length > 2 ? "space-between" : "flex-start",
          }}
        >
          {tabs.map((item, index) => {
            const isActive = tab === item.path
            return (
              <div className="relative h-full flex items-center" key={index}>
                <TabItem
                  title={item.name}
                  isActive={isActive}
                  onClick={() => {
                    setTab(item.path)
                    setSearchParams({ tab: item.path })
                  }}
                />
                {isActive ? (
                  <div
                    className="absolute bottom-[-1px] left-0 right-[6px] h-[4px] bg-[#FDBE44]"
                    style={{
                      borderTopLeftRadius: 10,
                      borderTopRightRadius: 10,
                    }}
                  ></div>
                ) : null}
              </div>
            )
          })}
        </div>
      </div>
    )
  }

  const renderAdminNotification = () => {
    return (
      <div className="flex flex-col items-center justify-center h-full px-6">
        <UserIcon
          style={{
            width: 250,
            height: 250,
          }}
        />
        <div className="flex flex-col items-center max-w-[600px] w-full">
          <p className="text-[20px] font-semibold text-[#111111] mb-3 text-center">
            {roleName} has full access!
          </p>
          <p className="text-[14px] text-[#7A7A7A] text-center mb-6">
            {`This user is an ${roleName} and automatically has access to all Groups and
            Projects in the workspace. Assigned permissions are not shown for
            ${roleName} users.`}
          </p>
          <Button
            title="Back to Users"
            widthBtn={200}
            onClick={() => {
              pushTo(PATH.userGroups)
            }}
          />
        </div>
      </div>
    )
  }

  const renderContent = () => {
    switch (tab) {
      case "group":
        return (
          <GroupTab
            userId={userId}
            isAdmin={hasPermission(userInfo, PERMISSIONS.USER_VIEW)}
          />
        )
      case "project":
        return (
          <ProjectTab
            userId={userId}
            isAdmin={hasPermission(userInfo, PERMISSIONS.USER_VIEW)}
          />
        )
      default:
        return null
    }
  }

  if (includes(["Workspace Owner", "Admin"], roleName)) {
    return <PageLayout heightHeader={0}>{renderAdminNotification()}</PageLayout>
  }

  return (
    <PageLayout childrenHeader={renderHeader()} heightHeader={48}>
      {renderContent()}
    </PageLayout>
  )
}
